import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import stylesPc from "./EditAndUploadToHubModal.module.css";
import stylesSp from "./EditAndUploadToHubModal_SP.module.css";
import styleIpad from "./EditAndUploadToHubModal_IP.module.css";
import { IsDevice } from "../function/useDeviceFlag";
import PuiMessage from "./PuiMessage";
import { ResetDuplicateError } from "../../common/video/VideoActions";
import {
    Checkbox,
    Chip,
    createStyles,
    createTheme,
    makeStyles,
    Modal,
    ThemeProvider
} from "@material-ui/core";
import SelectTag from "../../admin/viewer/SelectTag";
import UploadDocument from "../../pages/vod/Common/UploadDocument";
import { VideoExtraMaterial } from "../../common/video/models/VideoExtraMaterial";
import { t } from "i18next";

/**
|------------------------------------------------------------------
|  アップロード・動画編集ダイアログを下記の項目で分割するコンポーネント
|  サムネイル、タグ、資料
|------------------------------------------------------------------
*/

interface ModalLowerInputItemsProps {
    setIsSaved: (isSaved: boolean) => void;
    isOpenVideoModal: boolean;
    // サムネイル
    inputImageUrl: string;
    setInputImageUrl: (inputImageUrl: string) => void;
    inputImageFile: File | null;
    setInputImageFile: (inputImageFile: File | null) => void;
    visiblePreviewImage: number;
    ChangePreviewImageFlag: (visiblePreviewImage: number) => void;
    textImageFile: string;
    ChangeTextImageFile: (textImageFile: string) => void;
    // タグ
    tagList: string[];
    setTagList: (tagList: string[]) => void;
    isOpenTagSelectModal: boolean;
    ShowTagSelectModal: (isOpenTagSelectModal: boolean) => void;
    // 資料
    alreadyUploadDocumentList?: VideoExtraMaterial[];
    ChangeAlreadyUploadDocumentList?: (alreadyUploadDocumentList: VideoExtraMaterial[]) => void;
    documentList: File[];
    ChangeDocumentList: (documentList: File[]) => void;
    documentNameList: string[];
    ChangeDocumentNameList: (documentNameList: string[]) => void;
    ErrorDocumentListLength: (isErrorDocumentListLength: boolean) => void;
    //アップロード動画の言語
    sttLanguage: string;
    //言語
    languageJa: boolean;
    setLanguageJa: (languageEn: boolean) => void;
    languageEn: boolean;
    setLanguageEn: (languageEn: boolean) => void;
    languageZh: boolean;
    setLanguageZh: (languageZh: boolean) => void;
    languageVi: boolean;
    setLanguageVi: (languageVi: boolean) => void;
}

const useStyles = makeStyles(() =>
    createStyles({
        checkBox: {
            color: "white"
        }
    })
);

const theme = createTheme({
    palette: {
        secondary: {
            main: "#16ADC1"
        }
    }
});

function ModalLowerInputItems({
    setIsSaved,
    isOpenVideoModal,
    // サムネイル
    inputImageUrl,
    setInputImageUrl,
    inputImageFile,
    setInputImageFile,
    visiblePreviewImage,
    ChangePreviewImageFlag,
    textImageFile,
    ChangeTextImageFile,
    // タグ
    tagList,
    setTagList,
    isOpenTagSelectModal,
    ShowTagSelectModal,
    // 資料
    alreadyUploadDocumentList,
    ChangeAlreadyUploadDocumentList,
    documentList,
    ChangeDocumentList,
    documentNameList,
    ChangeDocumentNameList,
    ErrorDocumentListLength,
    //アップロード動画の言語
    sttLanguage,
    //言語
    languageJa,
    setLanguageJa,
    languageEn,
    setLanguageEn,
    languageZh,
    setLanguageZh,
    languageVi,
    setLanguageVi
}: //解像度
ModalLowerInputItemsProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : IsDevice("ipad") ? styleIpad : stylesSp;
    const classes = useStyles();
    const dispatch = useDispatch();

    // サムネイル開始
    const [isErrorInputSize, ChangeErrorInputSize] = useState(false);

    const inputImageRef = useRef<HTMLInputElement>(null);

    // ファイルサイズエラーバー消去
    const CloseErrorInputBar = () => {
        ChangeErrorInputSize(false);
    };

    const [isLimitInputImageSize, ChangeLimitInputImageSize] = useState(false);

    // サムネイルサイズ制限バー消去
    const CloseLimitInputImageBar = () => {
        ChangeLimitInputImageSize(false);
    };

    const [isLimitInputFileSize, ChangeLimitInputFileSize] = useState(false);

    // ファイルサイズ制限バー消去
    const CloseLimitInputFileBar = () => {
        ChangeLimitInputFileSize(false);
    };

    const ThumbnailChange = () => {
        const input = document.getElementById("browserPhotoUploader") as HTMLInputElement;
        if(input){
            input.click();
        }
    };

    const ClickPreviewImage = () => {
        ChangePreviewImageFlag(1);
        setInputImageFile(null);
        const input = document.getElementById("browserPhotoUploader") as HTMLInputElement;
        if(input){
            input.value="";
        }
    };

    const UserUploadImage = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) return;
        if (event.target.files.length === 0) {
            ChangeTextImageFile("アップロードするファイルを選択");
            setInputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
        } else if (event.target.files.length === 1) {
            if (event.target.files[0].size > 0) {
                if (event.target.files[0].size > 10485760) {
                    ChangeLimitInputImageSize(true);
                } else {
                    ChangeTextImageFile(event.target.files[0].name);
                    setInputImageFile(event.target.files[0]);
                    ChangePreviewImageFlag(3);
                    setIsSaved(false);
                }
            } else {
                ChangeErrorInputSize(true); 
                if (inputImageRef.current) {
                    inputImageRef.current.value = "";
                }
            }
        } else {
            ChangeTextImageFile("ファイルを正しく選択してください");
            setInputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
        }
    };
    //サムネイル終わり

    //タグ開始
    // タグ選択モーダル表示
    const OpenTagSelectModal = () => {
        ShowTagSelectModal(true);
    };
    // タグ選択モーダル非表示
    const CloseTagSelectModal = () => {
        ShowTagSelectModal(false);
        dispatch(ResetDuplicateError());
    };
    // ユーザタグ消去
    const handleDelete = (tagName: string) => () => {
        const newList = tagList.filter((v) => v !== tagName);
        setTagList(newList);
        setIsSaved(false);
    };
    // Addアイコンにマウス入る処理
    const [isMouseEnterInfo, setMouseEnterInfo] = useState<boolean>(false);
    //タグ終わり

    //STT言語選択
    const handleChangeLanguageJa = () => {
        setLanguageJa(!languageJa);
        setIsSaved(false);
    };
    const handleChangeLanguageEn = () => {
        setLanguageEn(!languageEn);
        setIsSaved(false);
    };
    const handleChangeLanguageZh = () => {
        setLanguageZh(!languageZh);
        setIsSaved(false);
    };
    const handleChangeLanguageVi = () => {
        setLanguageVi(!languageVi);
        setIsSaved(false);
    };

    useEffect(() => {
        if (inputImageRef.current) {
            inputImageRef.current.value = "";
        }
        // eslint-disable-next-line
    }, [isOpenVideoModal]);

    return (
        <>
            <ThemeProvider theme={theme}>
                {/* 画像サムネイルファイル */}
                <li>
                    <div className={styles.formHelperText} style={{ marginTop: "0" }}>
                        {t("サムネイル")}
                    </div>
                    {visiblePreviewImage === 1 && (
                        <>
                            <div className={styles.formHelperImage}>
                                <div className={styles.changeThumbs}>
                                    <div className={styles.previewImage}>
                                        <img
                                            id="thumbnailPreview"
                                            alt="defaultThumbnail"
                                            style={{ cursor: "pointer" }}
                                            src={inputImageUrl}
                                            onClick={ThumbnailChange}
                                        />
                                    </div>
                                    <div
                                        className={styles.changeThumbButton}
                                        onClick={ThumbnailChange}
                                    >
                                        <img
                                            alt="changeThumbnail"
                                            src={
                                                require("../../../src/assets/image/thumnail.svg")
                                                    .default
                                            }
                                        />
                                        <p className={styles.changeThumbIcon}>
                                            {" "}
                                            {t("サムネイルを変更")}
                                        </p>
                                        <input
                                            id="browserPhotoUploader"
                                            ref={inputImageRef}
                                            type="file"
                                            accept="image/*"
                                            onChange={UserUploadImage}
                                            className={styles.fileDisplay}
                                            style={{ display: "none" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {visiblePreviewImage === 3 && inputImageFile && (
                        <div>
                            <div className={styles.previewImage}>
                                <img
                                    alt="thumbnail"
                                    style={{ cursor: "pointer" }}
                                    src={window.URL.createObjectURL(inputImageFile)}
                                    onClick={ClickPreviewImage}
                                />
                            </div>
                            <div className={styles.form}>
                                <p className={styles.previewText}>{textImageFile}</p>
                            </div>
                        </div>
                    )}
                </li>

                {/* タグ（モーダル表示） */}
                <li style={{ marginBottom: "15px" }}>
                    <div className={styles.formHelperTextLong}>{t("タグ")}</div>
                    <div
                        className={styles.formTag}
                        style={{ marginBottom: "13px" }}
                        onMouseEnter={() => setMouseEnterInfo(true)}
                        onMouseLeave={() => setMouseEnterInfo(false)}
                    >
                        {!isMouseEnterInfo && (
                            <img
                                style={{
                                    cursor: "pointer",
                                }}
                                alt={"More"}
                                onClick={OpenTagSelectModal}
                                src={require("../../../src/assets/image/MoreIcon.svg").default}
                            />
                        )}
                        {isMouseEnterInfo && (
                            <img
                                style={{
                                    cursor: "pointer",
                                }}
                                alt={"More"}
                                onClick={OpenTagSelectModal}
                                src={
                                    require("../../../src/assets/image/MoreIcon_hover.svg").default
                                }
                            />
                        )}
                    </div>
                    <div className={styles.tags}>
                        {tagList &&
                            tagList.map((tag) => (
                                <Chip
                                    label={tag}
                                    key={tag}
                                    color="secondary"
                                    style={{
                                        backgroundColor: "#24282E",
                                        fontFamily: "noto-sans-cjk-jp",
                                        maxWidth: "100%",
                                    }}
                                    size="medium"
                                    className={styles.tag}
                                    onDelete={handleDelete(tag)}
                                />
                            ))}
                    </div>
                </li>

                {/* 資料 */}
                <li>
                    <div className={styles.formHelperTextLong}>{t("資料")}</div>
                    <div className={styles.documentIcon}>
                        <UploadDocument
                            alreadyUploadDocumentList={
                                alreadyUploadDocumentList ? alreadyUploadDocumentList : []
                            }
                            ChangeAlreadyUploadDocumentList={ChangeAlreadyUploadDocumentList}
                            ChangeDocumentList={ChangeDocumentList}
                            documentList={documentList}
                            ChangeDocumentNameList={ChangeDocumentNameList}
                            documentNameList={documentNameList}
                            ErrorDocumentListLength={ErrorDocumentListLength}
                            setIsSaved={setIsSaved}
                            isShowAddDocIcon={true}
                        />
                    </div>
                </li>
                <li>
                    <>
                        <div className={styles.formHelperTextLong}>{t("言語")}</div>
                        <div className={styles.formLang}>
                            <Checkbox
                                className={classes.checkBox}
                                color="secondary"
                                checked={languageJa}
                                onChange={handleChangeLanguageJa}
                                disabled={sttLanguage === "ja-JP"}
                                inputProps={{ "aria-label": "primary checkbox" }}
                            />
                            <span className={styles.formHelperTextLang}>{t("日本語")}</span>
                            <Checkbox
                                className={classes.checkBox}
                                color="secondary"
                                checked={languageEn}
                                onChange={handleChangeLanguageEn}
                                disabled={sttLanguage === "en-US"}
                                inputProps={{ "aria-label": "primary checkbox" }}
                            />
                            <span className={styles.formHelperTextLang}>{t("英語")}</span>
                            <Checkbox
                                className={classes.checkBox}
                                color="secondary"
                                checked={languageZh}
                                onChange={handleChangeLanguageZh}
                                disabled={sttLanguage === "zh-CN"}
                                inputProps={{ "aria-label": "primary checkbox" }}
                            />
                            <span className={styles.formHelperTextLang}>{t("中国語")}</span>
                            <Checkbox
                                className={classes.checkBox}
                                color="secondary"
                                checked={languageVi}
                                onChange={handleChangeLanguageVi}
                                disabled={sttLanguage === "vi-VN"}
                                inputProps={{ "aria-label": "primary checkbox" }}
                            />
                            <span className={styles.formHelperTextLang}>{t("ベトナム語")}</span>
                        </div>
                    </>
                </li>
            </ThemeProvider>

            {/* アップロードファイルサイズチェック */}
            <PuiMessage
                open={isLimitInputFileSize}
                onClose={CloseLimitInputFileBar}
                type="error"
                title="1GB以上のファイルはアップロードできません"
                duration={5000}
            />

            {/* アップロードイメージサムネイルサイズチェック */}
            <PuiMessage
                open={isLimitInputImageSize}
                onClose={CloseLimitInputImageBar}
                type="error"
                title="10MB以上の画像はアップロードできません"
                duration={5000}
            />

            {/* アップロードファイルサイズチェック */}
            <PuiMessage
                open={isErrorInputSize}
                onClose={CloseErrorInputBar}
                type="error"
                title="正しいファイルを選択してください"
                duration={5000}
            />

            {/*------------------------ タグ編集モーダル ------------------------*/}
            <Modal open={isOpenTagSelectModal} onClose={CloseTagSelectModal}>
                <SelectTag
                    in={isOpenTagSelectModal}
                    onClose={CloseTagSelectModal}
                    tagList={tagList}
                    setTagList={setTagList}
                    setIsSaved={setIsSaved}
                />
            </Modal>
        </>
    );
}

export default ModalLowerInputItems;
